import {Injectable} from '@angular/core';
import {from, Observable} from 'rxjs';
import {map, mergeMap} from 'rxjs/operators';
import {DeliveryCocMaterialModalComponent} from './delivery-coc-material-modal.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ArticleSpecificationService} from '../../../article/services/article-specification.service';
import {DeliveryCocMaterialMaterialSet} from './delivery-coc-material.model';
import {DeliveryListData} from '../../models/delivery.models';

@Injectable({
  providedIn: 'root',
})
export class DeliveryCocMaterialModalService {

  constructor(private articleSpecificationService: ArticleSpecificationService,
              private modalService: NgbModal) {
  }

  showModalWhenNeeded(delivery: DeliveryListData): Observable<DeliveryCocMaterialMaterialSet | null> {
    return delivery.material_saved ? this.fromDatabase() : this.fromModal(delivery);
  }

  private fromDatabase(): Observable<DeliveryCocMaterialMaterialSet | null> {
    return new Observable(o => {
      o.next(null);
      o.complete();
    });
  }

  private fromModal(delivery: DeliveryListData): Observable<DeliveryCocMaterialMaterialSet | null> {
    return from(this.showModal(delivery)).pipe(map(material => {
      if (!material) {
        return null;
      }

      return {
        material: material,
        materialSaved: true,
      } as DeliveryCocMaterialMaterialSet;
    }));
  }

  showModal(delivery: DeliveryListData): Observable<string> {
    return this.articleSpecificationService.manufacturerList()
      .pipe(mergeMap<string[], Observable<string>>(manufacturerList => {
        const ref = this.modalService.open(DeliveryCocMaterialModalComponent, {windowClass: 'modal2-sm'});
        ref.componentInstance.delivery = delivery;
        ref.componentInstance.materials = manufacturerList.filter(material => material !== 'Standard FR4');
        return from(ref.result).pipe(map(material => {
          return manufacturerList.find(m => m === material) ?? null;
        }));
      }));
  }
}
